export default "__VITE_ASSET__YN7L_Ytt__"